import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  Dialog,
} from "@material-ui/core";
import {
  ChevronLeft,
  ChevronRight,
  Clear,
  Refresh,
  ArrowBack,
} from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import AddIcon from "@material-ui/icons/Add";
import { Autocomplete } from "@material-ui/lab";
import React, { useState, useEffect, useMemo } from "react";
import moment from "moment";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import AddProductDialog from "./ModalPopups/AddProductDialog";
import ProductSelectionDialog from "./ModalPopups/ProductSelectionDialog";
import { useHistory } from "react-router-dom";
import { appUrl } from "../../../../../utils/config";
import axios from "axios";
import { saveDashboardFilters, fetchAllDashboardFilters } from '../../../containers/utils/filterUtils';
import CircularProgress from '@material-ui/core/CircularProgress';
import StyledDialog from '../../../../common/models/Dialog';
import { useSelector, useDispatch } from "react-redux";
import { getFeaturesAccess } from "../../../containers/actions/common/accessControl";

const useStyles = makeStyles((theme) => ({
  boldText: {
    fontWeight: "bold",
  },
  iconButtonStyle: {
    color: "black",
    border: "1px solid black",
    borderRadius: "5px",
    padding: "4px",
  },
  blueButton: {
    backgroundImage: "linear-gradient(to right, #301232, #1A2D6C,#173072)",
    color: "white",
    border: "1px solid black",
    textTransform: "none",
    borderRadius: "2rem",
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
    "&:hover": {
      backgroundColor: "green",
      background: "green",
      color: "white",
      border: "1px solid green",
    },
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    color: "#ec6535",
    marginBottom: "1rem",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  dpFlx: { display: "flex" },
  algnCntr: { alignItems: "center" },
  pointer: { cursor: "pointer" },
  onHvrUndrline: {
    "&:hover": {
      textDecoration: "underline",
    },
  },
  inputBaseRoot: {
    padding: "0px",
    paddingRight: "14px",
    height: "40px",
  },
  perpage: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  stripedRow: {
    "&:nth-of-type(even)": {
      backgroundColor: "#f9f9f9",
    },
  },
}));

const ClinicalSupply = (props) => {
  const { selectedSupplytype, productConfig , searchField: initialSearchField, searchValue: initialSearchValue} = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const [view, setView] = useState("ClinicalSupply");

  
  const screenAccess = useSelector((state) => {
    return state.pcmp.common.accessControl.screensAccess.data.manageProducts;
  });

  
  const featuresAccess = useSelector((state) => {
    return state.pcmp.common.accessControl.featuresAccess.manageProducts;
  });



  const [searchSelectValue, setSearchSelectValue] = useState(null);
  const [supplyTypes, setSupplyTypes] = useState([]);
  const [drugTypes, setDrugTypes] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [selectedDrugType, setSelectedDrugType] = useState("All");
  const [selectedProductType, setSelectedProductType] = useState("All");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [plantTypes, setPlantTypes] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10); // Default rows per page
  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const [totalRecords, setTotalRecords] = useState(0); // Total number of records
  const [loading, setLoading] = useState(false); // Loading state for API calls
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openProductSelectionDialog, setOpenProductSelectionDialog] =
    useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [pageLoading, setPageLoading] = useState(false);
  const [oppositeSupplytype, setOppositeSupplytype] = useState(null);
  const [searchFieldError, setSearchFieldError] = useState(false);
  const [searchValueError, setSearchValueError] = useState(false);
  const [saveDialogOpen, setSaveDialogOpen] = useState(false);
  const [saveDialogSuccess, setSaveDialogSuccess] = useState(true);
  const [lastSavedFilters, setLastSavedFilters] = useState({
    searchField: 'all',
    searchValue: '',
    selectedDrugType: 'all',
    selectedProductType: 'all',
    selectedStatus: 'all',
    rowsPerPage: 10,
  });
const isCMODashboard = props.searchField === "CMO" && !!props.searchValue;
const [searchField, setSearchField] = useState(isCMODashboard ? "CMO" : "all");
const [searchValue, setSearchValue] = useState(isCMODashboard ? props.searchValue : "");
  // Add this after your useState hooks, before return



  const classes = useStyles();


  const handleTabChange = (event, newValue) => {
    setView(newValue);
  };
 
  


  const apiBaseUrl = useMemo(() => {
    const appName = localStorage.getItem("appName");
    const network = localStorage.getItem("network");
    const collabType = localStorage.getItem("collabType");
    const roleName = localStorage.getItem("roleName");

    if (appName && network && collabType && roleName) {
      return `${appUrl}/${appName}/${network}/${collabType}/${roleName}`;
    }
    return null;
  }, [
    localStorage.getItem("appName"),
    localStorage.getItem("network"),
    localStorage.getItem("collabType"),
    localStorage.getItem("roleName"),
  ]);


  // Fetch drug types (Product Modality) data
  const fetchDrugTypes = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/fetchPlantDrugTypes/true`
      );

      if (response.data && response.data.status) {
        setDrugTypes(response?.data?.data?.drugTypeList);
      }
    } catch (error) {
      console.error("Error fetching drug types:", error);
    }
  };

  // Fetch product types data
  const fetchProductTypes = async () => {
    try {
      // Replace with your actual API endpoint
      const response = await axios.get(
        `${apiBaseUrl}/fetchProductTypes/true`
      );
      if (response.data && response.data.data.productTypeList) {
        setProductTypes(response.data.data.productTypeList);
      }
    } catch (error) {
      console.error("Error fetching product types:", error);
    }
  };
  

  // Handle change for all dropdown fields (Drug Type, Product Type, Status)
  
  // Call getFeaturesAccess when component mounts
  useEffect(() => {
    if (screenAccess?.screenAccess && !featuresAccess) {
      dispatch(getFeaturesAccess(screenAccess?.screenId, "manageProducts"));
    }
  }, [dispatch, screenAccess, featuresAccess]);

  useEffect(() => {
  fetchDrugTypes();
  fetchProductTypes();
  sessionStorage.clear();

  // Only run this block ONCE on mount, and only if coming from CMO dashboard
  if (isCMODashboard) {
  setSearchField("CMO");
  setSearchValue(props.searchValue);
  setSelectedDrugType("all");
  setSelectedProductType("all");
  setSelectedStatus("all");
  fetchAllProducts({
    searchField: "CMO",
    searchValue: props.searchValue,
    productModality: "all",
    productType: "all",
    status: "all",
    supplyTypeID: selectedSupplytype?.supplyTypeID,
    pageNumber: 1,
    pageSize: rowsPerPage,
  });
} else {
    // Restore filters if they exist
    const restoreFilters = async () => {
      try {
        const filters = await fetchAllDashboardFilters('clinicalSupplyDashboard');
        let f = (filters && filters.data && filters.data.clinicalSupplyDashboard) ? filters.data.clinicalSupplyDashboard : null;
        if (!f || Object.keys(f).length === 0) {
          setSearchField('all');
          setSearchValue('');
          setSelectedDrugType('all');
          setSelectedProductType('all');
          setSelectedStatus('all');
          setRowsPerPage(10);
          setCurrentPage(1);
          setLastSavedFilters({
            searchField: 'all',
            searchValue: '',
            selectedDrugType: 'all',
            selectedProductType: 'all',
            selectedStatus: 'all',
            rowsPerPage: 10,
          });
          const payload = {
            searchField: 'all',
            searchValue: null,
            productModality: 'all',
            productType: 'all',
            status: 'all',
            supplyTypeID: selectedSupplytype?.supplyTypeID,
            pageNumber: 1,
            pageSize: 10,
          };
          fetchAllProducts(payload);
        } else {
          setSearchField(f.searchField || 'all');
          setSearchValue(f.searchValue || '');
          setSelectedDrugType(f.selectedDrugType || 'all');
          setSelectedProductType(f.selectedProductType || 'all');
          setSelectedStatus(f.selectedStatus || 'all');
          setRowsPerPage(f.rowsPerPage || 10);
          setCurrentPage(1);  // Always start at page 1 when restoring filters
          setLastSavedFilters({
            searchField: f.searchField || 'all',
            searchValue: f.searchValue || '',
            selectedDrugType: f.selectedDrugType || 'all',
            selectedProductType: f.selectedProductType || 'all',
            selectedStatus: f.selectedStatus || 'all',
            rowsPerPage: f.rowsPerPage || 10,
          });
          const payload = {
            searchField: f.searchField || 'all',
            searchValue: f.searchValue || null,
            productModality: f.selectedDrugType || 'all',
            productType: f.selectedProductType || 'all',
            status: f.selectedStatus || 'all',
            supplyTypeID: selectedSupplytype?.supplyTypeID,
            pageNumber: 1,  // Always start at page 1
            pageSize: f.rowsPerPage || 10,
          };
          fetchAllProducts(payload);
        }
      } catch (e) {
        setSearchField('all');
        setSearchValue('');
        setSelectedDrugType('all');
        setSelectedProductType('all');
        setSelectedStatus('all');
        setRowsPerPage(10);
        setCurrentPage(1);
        setLastSavedFilters({
          searchField: 'all',
          searchValue: '',
          selectedDrugType: 'all',
          selectedProductType: 'all',
          selectedStatus: 'all',
          rowsPerPage: 10,
        });
        const payload = {
          searchField: 'all',
          searchValue: null,
          productModality: 'all',
          productType: 'all',
          status: 'all',
          supplyTypeID: selectedSupplytype?.supplyTypeID,
          pageNumber: 1,
          pageSize: 10,
        };
        fetchAllProducts(payload);
      }
    };
    restoreFilters();
  }
  // eslint-disable-next-line
}, []);
  const handleRoleChange = (event, fieldType) => {
    const value = event.target.value;

    let newDrugType = selectedDrugType;
    let newProductType = selectedProductType;
    let newStatus = selectedStatus;

    switch (fieldType) {
      case "drugType":
        newDrugType = value;
        setSelectedDrugType(value);
        break;
      case "productType":
        newProductType = value;
        setSelectedProductType(value);
        break;
      case "status":
        newStatus = value;
        setSelectedStatus(value);
        break;
      default:
        break;
    }

    setCurrentPage(1);

    const payload = {
      searchField: searchField !== "all" ? searchField : "all",
      searchValue: searchField !== "all" ? searchValue : null,
      productModality: newDrugType !== "all" ? newDrugType : "all",
      productType: newProductType !== "all" ? newProductType : "all",
      status: newStatus !== "all" ? newStatus : "all",
      supplyTypeID: selectedSupplytype?.supplyTypeID,
      pageNumber: 1,
      pageSize: rowsPerPage,
    };
    fetchAllProducts(payload);
  };
  const handleSearchField = (event) => {
    // Reset to page 1 when changing search parameters
    setCurrentPage(1);
    setSearchField(event.target.value);
    setSearchValue(null);
    setSearchSelectValue(null);
    setSearchFieldError(false);
    setSearchValueError(false);
  };

  // Field-specific regex and max length for search validation
  const searchFieldValidation = {
    "Sponsor Product Code": {
      regex: /^[a-zA-Z0-9\-_]{0,20}$/,
      maxLength: 20,
      error: "Invalid sponsor product code",
    },
    "Sponsor Product Description": {
      regex: /^[a-zA-Z0-9\s\-\.,\/()&:]{0,250}$/,
      maxLength: 250,
      error: "Invalid product description",
    },
    "CMO Product Code": {
      regex: /^[a-zA-Z0-9\-_]{0,25}$/,
      maxLength: 25,
      error: "Invalid CMO product code",
    },
    "CMO Product Description": {
      regex: /^[a-zA-Z0-9\s\-\.,\/()&:]{0,40}$/,
      maxLength: 40,
      error: "Invalid CMO product description",
    },
    "CMO": {
      regex: /^[a-zA-Z0-9\s&\-,./\'()]{0,40}$/,
      maxLength: 40,
      error: "Invalid CMO",
    },
  };

  const handleSearchClick = () => {
    if (searchField === "all") {
      setSearchFieldError(true);
      return;
    }

    if (searchField !== "all" && (!searchValue || searchValue.trim() === "")) {
      setSearchValueError(true);
      return;
    }

    // Field-specific validation
    if (searchFieldValidation[searchField]) {
      const { regex, maxLength } = searchFieldValidation[searchField];
      if (
        searchValue &&
        (!regex.test(searchValue) || searchValue.length > maxLength)
      ) {
        setSearchValueError(true);
        return;
      }
    }

    // If validation passes, proceed with search
    setSearchFieldError(false);
    setSearchValueError(false);

    // Reset to page 1 when searching
    setCurrentPage(1);
    fetchAllProducts();
  };
  const handleClearSearch = () => {
    setSearchValue("");
    setSearchSelectValue(null);
    setSearchFieldError(false);
    setSearchValueError(false);
    handleClearFilters();
  }; // State for storing product data
  const [productData, setProductData] = useState([]); // Fetch all products data
  const fetchAllProducts = async (payloadOverride) => {
    setLoading(true);
    let searchVal = typeof searchValue === 'string' && searchValue !== searchValue.trim() ? searchValue.trim() : searchValue
    const payload = payloadOverride || {
      searchField: searchField !== "all" ? searchField : "all",
      searchValue: searchField !== "all" ? searchVal : null,
      productModality: selectedDrugType !== "All" ? selectedDrugType : "all",
      productType: selectedProductType !== "All" ? selectedProductType : "all",
      status: selectedStatus !== "All" ? selectedStatus : "all",
      supplyTypeID: selectedSupplytype?.supplyTypeID,
      pageNumber: currentPage,
      pageSize: rowsPerPage,
    };
    try {
      const response = await axios.post(
        `${apiBaseUrl}/fetchAllProducts`,
        payload
      );
      if (response.data && response.data.status) {
        setProductData(response.data.productDetailsList || []);
        if (response.data.numberOfPages) {
          setTotalPages(response.data.numberOfPages);
          setTotalRecords(response.data.totalNoOfRecords || 0);
        } else {
          const estimatedTotalPages = Math.ceil(
            (response.data.productDetailsList?.length || 0) / (payload.pageSize || rowsPerPage)
          );
          setTotalPages(estimatedTotalPages > 0 ? estimatedTotalPages : 1);
          setTotalRecords(response.data.productDetailsList?.length || 0);
        }
      }
    } catch (error) {
      console.error("Error fetching products:", error?.message || error);
      setProductData([]);
      setTotalPages(1);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };
  // Use the data directly from the API response
  const data = productData;
  const getStatusStyle = (status) => {
    return {
      backgroundColor: status === "Active" ? "#408E0F" : status === "Pending" ? "#E78A00" : "#FF0000",
      width: "7rem",
      color: "white",
      padding: "5px 10px",
      borderRadius: "5px",
      textAlign: "center",
    };
  };

  // Function to handle viewing product details
  const handleViewProduct = (productRow) => {
    setPageLoading(true);
    axios
      .get(
        `${apiBaseUrl}/fetchProductDetails/${productRow.collabrixProductID}`
      )
      .then((response) => {
        if (response.data && response.data.status) {
          history.push({
            pathname: `productDevelopment/viewProduct`,
            state: {
              selectedProduct: productRow,
              configuredProductDetails: response.data.data,
              viewProductDetails: true
            },
          });
        } else {
          console.error(
            "Error in fetchProductDetails API response:",
            response.data
          );
          history.push({
            pathname: `productDevelopment/viewProduct`,
            state: { selectedProduct: productRow },
          });
        }
      })
      .catch((error) => {
        console.error("Error calling fetchProductDetails API:", error);
        history.push({
          pathname: `productDevelopment/viewProduct`,
          state: { selectedProduct: productRow },
        });
      })
      .finally(() => {
        setPageLoading(false);
      });
  };
  const handleAddProduct = () => {
    // Clear session storage to reset the stepper form data
    // sessionStorage.removeItem("productConfigFormData");
    // sessionStorage.removeItem("currentStep");
    // sessionStorage.removeItem("completedSteps");
    // sessionStorage.removeItem("addedStatusSelection");
    // sessionStorage.removeItem("addedDocumentDeliverables");
    // sessionStorage.removeItem("productAddedOnce");
    // sessionStorage.removeItem('emptyFgStatuses');
    // sessionStorage.removeItem('selectedReplicatedFromProductID');
    sessionStorage.clear();
    localStorage.removeItem("fileUploadedProduct");

    // Direct navigation to Product Development stepper (Clinical Supply)
    // Popup dialog commented out - using direct navigation
    // const commercialType = productConfig.find((item) => item.supplyTypeName === "Commercial Supply");
    // setOpenAddDialog(true);
    // setOppositeSupplytype(commercialType);
    
    sessionStorage.setItem("pdSelectionForNewProduct", true);
    history.push({
      pathname: "productDevelopment/addProduct",
      state: {
        selectedSupplytype: { ...selectedSupplytype, supplyTypeName: "Product Development" },
        addNewProductConfig: true
      },
    });
  };

  const handleUploadProduct = ()=>{
    sessionStorage.clear();
    localStorage.removeItem("fileUploadedProduct");
    history.push({
      pathname: "uploadProductDetails",
      state: { selectedSupplytype: { ...selectedSupplytype } },
    });
  }

  const handleDialogClose = () => {
    setOpenAddDialog(false);
  };
  const handleYes = () => {
    setOpenAddDialog(false);
    setOpenProductSelectionDialog(true);
    // Pass the opposite supply type (Commercial Supply)
    const commercialType = productConfig.find((item) => item.supplyTypeName === "Commercial Supply");
    setOppositeSupplytype(commercialType);
  };

  const handleNo = () => {
    setOpenAddDialog(false);
    // sessionStorage.removeItem("productConfigFormData");
    // sessionStorage.removeItem("currentStep");
    // sessionStorage.removeItem("completedSteps");
    sessionStorage.clear();
    sessionStorage.setItem("pdSelectionForNewProduct", true);
    // Navigate to Product Development stepper (Clinical Supply)
    history.push({
      pathname: "productDevelopment/addProduct",
      state: { selectedSupplytype: { ...selectedSupplytype, supplyTypeName: "Product Development" }, addNewProductConfig: true, selectionForNewProduct: true},
    });
  };


  const handleProductSelectionClose = () => {
    setOpenProductSelectionDialog(false);
  };
  const handleProductSelectionContinue = async (selectedProduct) => {
    setSelectedProduct(selectedProduct);
    setOpenProductSelectionDialog(false);
    // sessionStorage.removeItem("productConfigFormData");
    // sessionStorage.removeItem("currentStep");
    // sessionStorage.removeItem("completedSteps");
    sessionStorage.clear();
    const commercialType = productConfig.find((item) => item.supplyTypeName === "Commercial Supply");
    if (selectedProduct.collabrixProductID) {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/fetchProductDetails/${selectedProduct.collabrixProductID}`
        );
        if (response.data && response.data.status) {
          sessionStorage.setItem("pdSelectionForNewProduct", true);
          
          // Override the supply type with the current context's supply type
          const productDetailsWithCorrectSupplyType = {
            ...response.data.data.productDetails,
            supplyTypeID: selectedSupplytype?.supplyTypeID,
            supplyTypeName: "Product Development"
          };

          // Navigate to Product Development stepper (Clinical Supply)
          history.push({
            pathname: "productDevelopment/addProduct",
            state: {
              selectedProduct,
              productDetails: productDetailsWithCorrectSupplyType,
              materialDetails: response.data.data.materialDetails,
              selectedSupplytype: { ...selectedSupplytype, supplyTypeName: "Product Development" },
              addNewProductConfig: true,
              selectionForNewProduct: true
            },
          });
          return;
        }
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    }
    // Navigate to Product Development stepper (Clinical Supply)
    history.push({
      pathname: "productDevelopment/addProduct",
      state: {
        selectedProduct,
        selectedSupplytype: { ...selectedSupplytype, supplyTypeName: "Product Development" },
        addNewProductConfig: true
      },
    });
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
      // Pass the current state values directly to fetch function instead of relying on state update
      const fetchWithNewPage = async () => {
        setLoading(true);
        const payload = {
          searchField: searchField !== "all" ? searchField : "all",
          searchValue: searchField !== "all" ? searchValue : null,
          productModality:
            selectedDrugType !== "All" ? selectedDrugType : "all",
          productType:
            selectedProductType !== "All" ? selectedProductType : "all",
          status: selectedStatus !== "All" ? selectedStatus : "all",
          supplyTypeID: selectedSupplytype?.supplyTypeID,
          pageNumber: newPage, // Use the new page directly
          pageSize: rowsPerPage,
        };

        try {
          const response = await axios.post(
            `${apiBaseUrl}/fetchAllProducts`,
            payload
          );
          if (response.data && response.data.status) {
            setProductData(response.data.productDetailsList || []);

            if (response.data.numberOfPages) {
              setTotalPages(response.data.numberOfPages);
              setTotalRecords(response.data.totalNoOfRecords || 0);
            } else {
              const estimatedTotalPages = Math.ceil(
                (response.data.productDetailsList?.length || 0) / rowsPerPage
              );
              setTotalPages(estimatedTotalPages > 0 ? estimatedTotalPages : 1);
              setTotalRecords(response.data.productDetailsList?.length || 0);
            }
          }
        } catch (error) {
          console.error("Error fetching products:", error?.message || error);
          setProductData([]);
          setTotalPages(1);
          setTotalRecords(0);
        } finally {
          setLoading(false);
        }
      };

      fetchWithNewPage();
    }
  };



  const handleSaveFilter = async () => {
    const filtersToSave = {
      searchField,
      searchValue,
      selectedDrugType,
      selectedProductType,
      selectedStatus,
      rowsPerPage,
    };
    try {
      await saveDashboardFilters('clinicalSupplyDashboard', filtersToSave);
      setSaveDialogSuccess(true);
      setSaveDialogOpen(true);
      setLastSavedFilters(filtersToSave);
    } catch (error) {
      setSaveDialogSuccess(false);
      setSaveDialogOpen(true);
    }
  };

  const filtersChanged = () => {
    return (
      searchField !== lastSavedFilters.searchField ||
      searchValue !== lastSavedFilters.searchValue ||
      selectedDrugType !== lastSavedFilters.selectedDrugType ||
      selectedProductType !== lastSavedFilters.selectedProductType ||
      selectedStatus !== lastSavedFilters.selectedStatus ||
      rowsPerPage !== lastSavedFilters.rowsPerPage
    );
  };
  const handleClearFilters = async () => {
    setSelectedDrugType("all");
    setSelectedProductType("all");
    setSelectedStatus("all");
    setSearchField("all");
    setSearchValue("");
    setSearchSelectValue(null);
    setCurrentPage(1);
    setRowsPerPage(10);
    // Save default filters after clearing
    const defaultFilters = {
      searchField: "all",
      searchValue: null,
      selectedDrugType: "all",
      selectedProductType: "all",
      selectedStatus: "all",
      rowsPerPage: 10,
      supplyTypeID: selectedSupplytype?.supplyTypeID,
    };
    try {
      // await saveDashboardFilters('clinicalSupplyDashboard', defaultFilters);
      // setLastSavedFilters({
      //   searchField: "all",
      //   searchValue: "",
      //   selectedDrugType: "all",
      //   selectedProductType: "all",
      //   selectedStatus: "all",
      //   rowsPerPage: 10,
      // });
      // Call fetchAllProducts with default payload
      const defaultPayload = {
        searchField: "all",
        searchValue: null,
        productModality: "all",
        productType: "all",
        status: "all",
        supplyTypeID: selectedSupplytype?.supplyTypeID,
        pageNumber: 1,
        pageSize: 10,
      };
      await fetchAllProducts(defaultPayload);
    } catch (e) { }
  };

  const handleEditProduct = async (row) => {
    try {

      // Existing flow for non-pending products
      const response = await axios.get(
        `${apiBaseUrl}/fetchProductDetails/${row.collabrixProductID}`
      );
      if (response.data && response.data.status) {
        // sessionStorage.removeItem("productAddedOnce");
        // sessionStorage.removeItem('emptyFgStatuses');
        // sessionStorage.removeItem('selectedReplicatedFromProductID');
        sessionStorage.clear();

        // Check if product status is pending
        if (row.dashboardStatus === 'Pending') {
          history.push({
            pathname: "productDevelopment/addProduct",
            state: {
              selectedProduct: row,
              selectedSupplytype: {
                supplyTypeName: response.data.data.productDetails.supplyTypeName,
                supplyTypeID: response.data.data.productDetails.supplyTypeID
              },
              productDetails: response.data.data.productDetails,
              selectedProductFormData: response.data.data,
              isEdit: true,
              isPending: true,
            },
          });
          return;
        }
        else {
          history.push({
            pathname: 'productDevelopment/editProduct',
            state: {
              selectedProduct: row,
              selectedSupplytype: {
                supplyTypeName: response.data.data.productDetails.supplyTypeName,
                supplyTypeID: response.data.data.productDetails.supplyTypeID
              },
              productDetails: response.data.data.productDetails,
              configuredProductDetails: response.data.data,
              selectedProductFormData: response.data.data,
              isEdit: true,
              isNotPending: true,
            }
          });
        }
      }
    } catch (error) {
      console.error('Error handling edit:', error);
      // You might want to show an error message to the user here
    }
  };

  return (
    <>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "1rem",
        }}
      >
        <Grid
          item
          style={{
            display: "flex",
            alignItems: "center",
            width: "40%",
            flexBasis: "40%",
            maxWidth: "40%",
          }}
        >
          <Box
            style={{
              display: "flex",
              flexGrow: 1,
            }}
            className="select-search-by-field"
          >
            {" "}
            
      {/* <React.Fragment> */}
            <TextField
              size="small"
              select
              // fullWidth
              value={searchField}
              onChange={handleSearchField}
             
              onKeyDown={(e) => e.key === "Enter" && handleSearchClick()}
              variant="outlined"
              error={searchFieldError}
              helperText={searchFieldError ? "Please select a search field" : ""}
              FormHelperTextProps={{
                style: {
                  position: 'absolute',
                  bottom: '-20px',
                  left: '0',
                  fontSize: '0.75rem',
                }
              }}
              style={{
                minWidth: 255,
                borderColor: searchFieldError ? " #f44336" : " #000",
              }}
              SelectProps={{
                MenuProps: {
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                },
              }}
              className="select-search"
            >
              <MenuItem value="all">Select Search By</MenuItem>
              <MenuItem value="Sponsor Product Code">
                Sponsor Product Code
              </MenuItem>
              <MenuItem value="Sponsor Product Description">
                Sponsor Product Description
              </MenuItem>
              <MenuItem value="CMO Product Code">CMO Product Code</MenuItem>
              <MenuItem value="CMO Product Description">
                CMO Product Description
              </MenuItem>
              <MenuItem value="CMO">CMO</MenuItem>
            </TextField>{" "}
            <TextField
              className="search-textbox"
              size="small"
              value={searchValue}
              disabled={searchField === "all"}
              error={searchValueError}
              helperText={
                searchValueError && searchFieldValidation[searchField]
                  ? searchFieldValidation[searchField].error
                  : searchValueError
                    ? "Please enter a valid search value"
                    : ""
              }
              FormHelperTextProps={{
                style: {
                  position: 'absolute',
                  bottom: '-20px',
                  left: '0',
                  fontSize: '0.75rem',
                }
              }}
              inputProps={{
                maxLength: searchFieldValidation[searchField]?.maxLength || 250,
              }}
              onInput={(e) => {
                // Prevent invalid characters from being typed in real-time
                if (searchField !== "all" && searchFieldValidation[searchField]) {
                  const { regex } = searchFieldValidation[searchField];
                  const inputValue = e.target.value;
                  
                  // Test the new input value against the regex
                  if (regex && !regex.test(inputValue)) {
                    // Prevent the invalid character from being entered
                    e.preventDefault();
                    e.target.value = searchValue; // Restore the previous valid value
                    return false;
                  }
                }
              }}
              onChange={(e) => {
                if (searchField !== "all") {
                  const { regex } = searchFieldValidation[searchField] || {};
                  const val = e.target.value;
                  if (
                    !regex ||
                    regex.test(val)
                  ) {
                    setSearchValue(val);
                    if (searchValueError) setSearchValueError(false);
                  }
                }
              }}
              onBlur={(e) => {
                const { value } = e.target;
                // Trim leading and trailing spaces for string values
                if (typeof value === "string" && value.trim() !== value) {
                  const trimmedValue = value.trim();
                  if (searchField !== "all") {
                    setSearchValue(trimmedValue);
                  }
                }
              }}
              onKeyDown={(e) => {
                const { value } = e.target;
                // Trim leading and trailing spaces for string values
                
                if (e.key === "Enter" && searchField !== "all") {
                  if (typeof value === "string" && value.trim() !== value) {
                  const trimmedValue = value.trim();
                  if (searchField !== "all") {
                    setSearchValue(trimmedValue);
                  }
                }
                  if (
                    searchFieldValidation[searchField] &&
                    !searchFieldValidation[searchField].regex.test(searchValue)
                  ) {
                    setSearchValueError(true);
                    return;
                  }
                  handleSearchClick();
                }
              }}
              variant="outlined"
              placeholder="Search"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {searchValue && (
                      <Tooltip title="Clear search" aria-label="clear">
                        <Clear
                          fontSize="small"
                          onClick={handleClearSearch}
                          style={{
                            cursor: "pointer",
                            color: "dimgray",
                          }}
                        />
                      </Tooltip>
                    )}
                    <IconButton
                      size="small"
                      style={{
                        backgroundColor: "#EB5E28",
                        color: "white",
                        borderRadius: "0 6px 6px 0",
                        padding: "8px",
                        translate: "0.84rem",
                      }}
                      onClick={() => {
                        if (
                          searchFieldValidation[searchField] &&
                          !searchFieldValidation[searchField].regex.test(searchValue)
                        ) {
                          setSearchValueError(true);
                          return;
                        }
                        handleSearchClick();
                      }}
                    >
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
             
            />
            {["Supply type", "Drug type", "Plant type"].includes(
              searchField
            ) && (
                <Autocomplete
                  options={
                    searchField === "Supply type"
                      ? supplyTypes
                      : searchField === "Drug type"
                        ? drugTypes
                        : searchField === "Plant type"
                          ? plantTypes
                          : []
                  }
                  getOptionLabel={(option) => {
                    if (searchField === "Supply type") {
                      return option.supplyType;
                    } else if (searchField === "Drug type") {
                      return option.drugType;
                    } else {
                      return option.plantType;
                    }
                  }}
                  value={searchSelectValue || null}
                  onChange={(e, value) => {
                    if (searchField !== "all") {
                      // handleSelectTypeValue(value)
                      setSearchSelectValue(value);
                      if (typeof value === "object") {
                        setSearchValue(
                          searchField === "Supply type"
                            ? String(value.supplyTypeID)
                            : searchField === "Drug type"
                              ? String(value.drugTypeID)
                              : searchField === "Plant type"
                                ? String(value.plantTypeID)
                                : null
                        );
                      } else {
                        setSearchValue("");
                      }
                    }
                  }}
                  style={{
                    width: "100%",
                    flex: 1,
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      value={searchValue}
                      variant="outlined"
                      placeholder="Search"
                      onChange={(e) => {
                        if (searchField !== "all") {
                          // handleSearchValue(e);
                        }
                      }}
                      InputProps={{
                        ...params.InputProps,
                        className: classes.inputBaseRoot,
                        endAdornment: (
                          <InputAdornment position="end">
                            {searchValue && (
                              <Tooltip title="Clear search" aria-label="clear">
                                {" "}
                                <Clear
                                  fontSize="small"
                                  onClick={handleClearSearch} // Clear search value
                                  style={{
                                    cursor: "pointer",
                                    color: "dimgray",
                                  }}
                                />
                              </Tooltip>
                            )}{" "}
                            <IconButton
                              size="small"
                              style={{
                                backgroundColor: "#EB5E28",
                                color: "white",
                                borderRadius: "0",
                                padding: "8px",
                                translate: "0.84rem",
                              }}
                              disabled={!searchSelectValue}
                              onClick={handleSearchClick} // Trigger API call on click
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )} // Disable until PO is selected
                />
              )}
                {/* </React.Fragment> */}
              
          </Box>
        </Grid>
        <Grid item>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            
                  {(featuresAccess?.uploadProductDetails === true &&
              <>
                  <Button
                    startIcon={<AddIcon />}
                    className={classes.blueButton}
                    onClick={handleUploadProduct}
                  >
                    Upload Product Details
                  </Button>
                  </>
                  )}

                  {(featuresAccess?.addNewProduct === true &&
              <>
                  <Button
                    startIcon={<AddIcon />}
                    className={classes.blueButton}
                    onClick={handleAddProduct}
                  >
                    Add New Product
                  </Button>
                  </>
                  )}
          </div>
        </Grid>
      </Grid>
      <Grid
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "10px",
        }}
        className="search-actions"
        container
      >
        <Grid
          item
          md={"auto"}
          style={{
            display: "flex",
            alignItems: "flex-end",
            gap: "20px",
          }}
        >
          <Grid
            style={{
              display: "flex",
              alignItems: "flex-start",
             
              flexDirection: "column",
              marginTop: "1.5rem",
            }}
          >
            <Grid>
              <Typography className="dashboard-filter-labels">
                Product Modality:
              </Typography>
            </Grid>

            <Grid>
              <FormControl
                variant="outlined"
                size="small"
                style={{ width: "13rem" }}
                className="dashboard-filter-dropdown"
              >
                <TextField
                  size="small"
                  select
                  variant="outlined"
                  placeholder="Choose option"
                  value={selectedDrugType}
                  onChange={(e) => handleRoleChange(e, "drugType")}
                >
                  <MenuItem key="all" value="all">
                    All
                  </MenuItem>
                  {drugTypes &&
                    drugTypes.map((option) => (
                      <MenuItem
                        key={option.drugTypeID}
                        value={option.drugTypeID}
                      >
                        {option.drugTypeName}
                      </MenuItem>
                    ))}
                </TextField>
              </FormControl>
            </Grid>
          </Grid>

          <Grid
            style={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
              marginTop: "1.5rem",
            }}
          >
            <Grid>
              <Typography className="dashboard-filter-labels">
                Product Type:
              </Typography>
            </Grid>

            <Grid>
              <FormControl
                variant="outlined"
                size="small"
                style={{ width: "13rem" }}
                className="dashboard-filter-dropdown"
              >
                <TextField
                  size="small"
                  select
                  variant="outlined"
                  placeholder="Choose option"
                  value={selectedProductType}
                  onChange={(e) => handleRoleChange(e, "productType")}
                >
                  <MenuItem key="all" value="all">
                    All
                  </MenuItem>
                  {productTypes.map((option) => (
                    <MenuItem
                      key={option.productTypeID}
                      value={option.productTypeID}
                    >
                      {option.productTypeName}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
            </Grid>
          </Grid>

          <Grid
            style={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
              marginTop: "1.5rem",
            }}
          >
            <Grid>
              <Typography className="dashboard-filter-labels">Status:</Typography>
            </Grid>

            <Grid>
              <FormControl
                variant="outlined"
                size="small"
                style={{ width: "13rem" }}
                className="dashboard-filter-dropdown"
              >
                <TextField
                  size="small"
                  select
                  variant="outlined"
                  placeholder="Choose option"
                  value={selectedStatus}
                  onChange={(e) => handleRoleChange(e, "status")}
                >
                  <MenuItem key="all" value="all">
                    All
                  </MenuItem>
                  <MenuItem key="active" value="Active">
                    Active
                  </MenuItem>
                  <MenuItem key="inactive" value="Inactive">
                    Inactive
                  </MenuItem>
                  <MenuItem key="pending" value="Pending">
                    Pending
                  </MenuItem>
                </TextField>
              </FormControl>
            </Grid>
          </Grid>

          <Grid
            style={{
              display: "flex",
              alignItems: "center",
              // alignSelf: "center",
              gap: 20,
              // marginTop: "4rem",
            }}
          >
            {/* Save Filters Button */}
            <Grid item xs="auto">
              {" "}
              <Button
                style={{
                  borderRadius: "5rem",
                  whiteSpace: "nowrap",
                  cursor: "pointer",
                  backgroundColor: "#ec6535",
                  color: "#fff",
                  textTransform: "none",
                }}
                onClick={handleSaveFilter}
                disabled={!filtersChanged()}
              >
                Save filters
              </Button>
            </Grid>{" "}
            {/* Clear All Filters */}{" "}
            <Grid
              item
              xs="auto"
              onClick={handleClearFilters}
            >
              <Typography
                variant="caption"
                style={{
                  fontSize: 14,
                  color: "#286ACF",
                  cursor: "pointer",
                  textDecoration: "underline",
                  whiteSpace: "nowrap",
                }}
              >
                Clear all filters
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          md={"auto"}
          className="sync-refresh-container"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "flex-end",
            marginTop: "1.5rem",
          }}
        >
          <div className="sync-refresh">
            <Typography
              variant="body2"
           
              className="last-synced-text"
            >
              {`Last synced @ ${moment(new Date()).format(
                "HH:mm:ss; DD MMMM YYYY"
              )}`}
            </Typography>
            <Typography
              variant="body2"
              color="primary"
              className="refresh-button"
              onClick={() => {
                const initialPayload = {
                  searchField: "all",
                  searchValue: null,
                  productModality: "all",
                  productType: "all",
                  status: "all",
                  supplyTypeID: selectedSupplytype?.supplyTypeID,
                  pageNumber: 1,
                  pageSize: rowsPerPage,
                };
                fetchAllProducts(initialPayload);
              }}
            >
              Refresh
              <Refresh color="primary" fontSize="small" />
            </Typography>
          </div>
          <div className={`${classes.perpage} per-page-box  per-page-container`}>
            <Typography
              style={{
                fontWeight: "bold",
                marginRight: "4px",
                whiteSpace: "nowrap",
              }}
            >
              PER PAGE
            </Typography>{" "}
            <FormControl variant="outlined" size="small">
              {" "}
              <Select
                value={rowsPerPage}
                onChange={(e) => {
                  const newRowsPerPage = e.target.value;
                  setRowsPerPage(newRowsPerPage);
                  setCurrentPage(1); // Reset to page 1 when changing rows per page

                  // Pass the new rows per page directly to fetchAllProducts instead of relying on state update
                  const fetchWithNewRowsPerPage = async () => {
                    setLoading(true);
                    const payload = {
                      searchField: searchField !== "all" ? searchField : "all",
                      searchValue: searchField !== "all" ? searchValue : null,
                      productModality:
                        selectedDrugType !== "All" ? selectedDrugType : "all",
                      productType:
                        selectedProductType !== "All"
                          ? selectedProductType
                          : "all",
                      status: selectedStatus !== "All" ? selectedStatus : "all",
                      supplyTypeID: selectedSupplytype?.supplyTypeID,
                      pageNumber: 1, // Reset to page 1
                      pageSize: newRowsPerPage, // Use the new rows per page directly
                    };

                    try {
                      const response = await axios.post(
                        `${apiBaseUrl}/fetchAllProducts`,
                        payload
                      );

                      if (response.data && response.data.status) {
                        setProductData(response.data.productDetailsList || []);

                        if (response.data.pagination) {
                          setTotalPages(
                            response.data.pagination.totalPages || 1
                          );
                          setTotalRecords(
                            response.data.pagination.totalRecords || 0
                          );
                        } else {
                          const estimatedTotalPages = Math.ceil(
                            (response.data.productDetailsList?.length || 0) /
                            newRowsPerPage
                          );
                          setTotalPages(
                            estimatedTotalPages > 0 ? estimatedTotalPages : 1
                          );
                          setTotalRecords(
                            response.data.productDetailsList?.length || 0
                          );
                        }
                      }
                    } catch (error) {
                      console.error("Error fetching products:", error?.message || error);
                      setProductData([]);
                      setTotalPages(1);
                      setTotalRecords(0);
                    } finally {
                      setLoading(false);
                    }
                  };

                  fetchWithNewRowsPerPage();
                }}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          </div>
        </Grid>
      </Grid>{" "}
      <TableContainer
        style={{ marginTop: "40px", border: "1px solid #bdbdbd", maxHeight: "48vh" }}
        component={Paper}
        className="default-table-styles"
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell className={classes.boldText}>
                Sponsor Product Code / Description
              </TableCell>
              {/* <TableCell className={classes.boldText}>Sponsor UOM</TableCell> */}
              <TableCell className={classes.boldText}>CMO</TableCell>
              <TableCell className={classes.boldText}>
                CMO Product Code / Description
              </TableCell>
              <TableCell className={classes.boldText}>Receiving Plant ID From Sponsor ERP</TableCell>
             
              {/* <TableCell className={classes.boldText}>CMO UOM</TableCell> */}
              <TableCell className={classes.boldText}>Brand</TableCell>
              <TableCell className={classes.boldText}>Status</TableCell>
              <TableCell className={classes.boldText}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {" "}
            {loading ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  <Typography>Loading products...</Typography>
                </TableCell>
              </TableRow>
            ) : productData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  <Typography>No products found</Typography>
                </TableCell>
              </TableRow>
            ) : (
              productData.map((row, index) => (
                <TableRow key={index} className={classes.stripedRow}>
                  <TableCell>{`${row.sponsorProductCode} / ${row.sponsorProductDescription}`}</TableCell>
                  {/* <TableCell>{row.sponsorUOM || "N/A"}</TableCell> */}
                  <TableCell>{row.vendorName || "N/A"}</TableCell>
                  <TableCell>
                    {row.cmoProductDetailsList && row.cmoProductDetailsList.length > 0 ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                        {row.cmoProductDetailsList.map((cmoProduct, idx) => (
                          <div key={idx}>
                            {`${cmoProduct.cmoProductCode} / ${cmoProduct.cmoProductDescription}`}
                          </div>
                        ))}
                      </div>
                    ) : (
                      "N/A"
                    )}
                  </TableCell>
                  <TableCell>{row.receivingPlantIDFromSponsorERP || "N/A"}</TableCell>
                  
                  {/* <TableCell>{row.cmoUOM || "N/A"}</TableCell> */}
                  <TableCell>{row.brand || "N/A"}</TableCell>
                  <TableCell>
                    <div style={getStatusStyle(row.dashboardStatus)}>{row.dashboardStatus}</div>
                  </TableCell>{" "}
                  <TableCell>
                    <Grid style={{ display: "flex", gap: 8 }}>

                      {/* {(featuresAccess?.viewProductDetails === true && */}
              <>
                      <IconButton
                        className={classes.iconButtonStyle}
                        style={{ marginRight: "10px" }}
                        onClick={() => handleViewProduct(row)}
                      >
                        <VisibilityIcon />
                      </IconButton>
                      </>
                      {/* )} */}

                      {(featuresAccess?.editProductDetails === true &&
              <>
                      <IconButton
                        className={classes.iconButtonStyle}
                        onClick={() => handleEditProduct(row)}
                      >
                        <EditIcon />
                      </IconButton>
                      </>
                      )}
                    </Grid>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>{" "}
      {/* Pagination Controls */}{" "}
      {!loading && productData.length > 0 && (
        <Box
          style={{
            marginTop: 24,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingRight: "2rem",
          }}
        >
          <IconButton
            disabled={currentPage <= 1}
            onClick={() => handlePageChange(currentPage - 1)}
          >
            <ChevronLeft />
          </IconButton>
          <Typography style={{ margin: "0 16px" }}>
            Page {currentPage} of {totalPages}{" "}
          </Typography>
          <IconButton
            disabled={currentPage >= totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
          >
            <ChevronRight />
          </IconButton>
        </Box>
      )}
      {/* Popup dialogs commented out - using direct navigation to Product Development stepper */}
      {/* <AddProductDialog
        open={openAddDialog}
        onClose={handleDialogClose}
        onYes={handleYes}
        onNo={handleNo}
        selectedSupplytype={oppositeSupplytype}
      />
      <ProductSelectionDialog
        open={openProductSelectionDialog}
        onClose={handleProductSelectionClose}
        onContinue={handleProductSelectionContinue}
        selectedSupplytype={oppositeSupplytype}
      /> */}
      <Dialog open={saveDialogOpen} onClose={() => setSaveDialogOpen(false)} fullWidth maxWidth="sm">
        <StyledDialog
          title={saveDialogSuccess ? 'Saved successfully' : 'Failed to save filters'}
          subtitle={saveDialogSuccess ? 'Filters saved successfully!' : 'Failed to save filters.'}
          icon={!saveDialogSuccess} // false = check, true = cross
          handleClose={() => setSaveDialogOpen(false)}
          noCloseButton={true}
        />
      </Dialog>
      {pageLoading && (
        <Box
          position="fixed"
          top={0}
          left={0}
          width="100vw"
          height="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bgcolor="rgba(255,255,255,0.6)"
          zIndex={2000}
          style={{ zIndex: 2000 }}
        >
          <CircularProgress size={60} color="primary" />
        </Box>
      )}
    </>
  );
};

export default ClinicalSupply;
